/* ppz-carousel.js — frecce e pallini condivisi da tutte le file scorrevoli.
 *
 * Contratto: la sezione porta data-ppz-carousel, dentro c'e' un contenitore
 * con data-ppz-track (che scorre) e la navigazione resa da ppz-carousel-nav.
 * Ogni figlio diretto del track e' un elemento del carosello.
 *
 * Se la fila ci sta tutta la navigazione si nasconde: con pochi prodotti
 * frecce e pallini sarebbero decorazione inutile.
 */
(function () {
  var GAP_FALLBACK = 16;

  function init(root) {
    if (root.dataset.ppzCarousel === 'ready') return;
    root.dataset.ppzCarousel = 'ready';

    var track = root.querySelector('[data-ppz-track]');
    var nav = root.querySelector('[data-ppz-nav]');
    if (!track || !nav) return;

    var prev = nav.querySelector('[data-ppz-prev]');
    var next = nav.querySelector('[data-ppz-next]');
    var dots = Array.prototype.slice.call(nav.querySelectorAll('[data-ppz-dot]'));
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;

    function step() {
      return items[0].getBoundingClientRect().width + GAP_FALLBACK;
    }

    /* offsetLeft e' relativo all'antenato posizionato, non al track: si
       normalizza sul primo elemento, cosi' il conto regge comunque. */
    function offsetOf(el) {
      return el.offsetLeft - items[0].offsetLeft;
    }

    function currentIndex() {
      var left = track.scrollLeft;
      var best = 0;
      var bestDistance = Infinity;
      items.forEach(function (el, i) {
        var d = Math.abs(offsetOf(el) - left);
        if (d < bestDistance) { bestDistance = d; best = i; }
      });
      return best;
    }

    function sync() {
      var scrollable = track.scrollWidth - track.clientWidth > 4;
      nav.classList.toggle('ppz-cnav--hidden', !scrollable);

      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;

      var c = currentIndex();
      dots.forEach(function (dot, i) {
        if (i === c) { dot.setAttribute('aria-current', 'true'); }
        else { dot.removeAttribute('aria-current'); }
      });
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: offsetOf(items[i]), behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-ppz-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Il theme editor ricrea le sezioni senza ricaricare la pagina. */
  document.addEventListener('shopify:section:load', boot);
})();
